// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-a2b24880] .v-text-field input{padding:0!important}[data-v-a2b24880] .v-expansion-panel-content__wrap{padding-top:16px}[data-v-a2b24880] .v-input__slot{padding:0 12px!important}#home_secondSection[data-v-a2b24880] .v-expansion-panel-content__wrap{padding-left:10px!important;padding-right:10px!important}.ProseMirror-focused[data-v-a2b24880]{outline:none}[data-v-a2b24880] .ProseMirror{padding:10px}.sidebar[data-v-a2b24880]{z-index:7!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
